import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IPropertySearchInstances } from '@llws/lift-entity-interfaces';
import { IAction, IStateStrictV2 } from '@/shared/interfaces/store-base';
import { IModifyPayload } from '@/shared/interfaces/modify-payload';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/property_search_instances';
const cloneResourcePath: string = '/web-components-api/clone_property_search_instances';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [],
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [],

};
const base = new StoreBaseImplementationV2<IPropertySearchInstances>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,

    /**
     * Saves an instance via the clone endpoint. The payload's `data.key` identifies the
     * source instance to clone; the BE looks it up and clones its relational data onto
     * the saved record.
    */
    cloneInstance: async (
      ctx: IAction<IStateStrictV2<IPropertySearchInstances>>,
      payload: IModifyPayload<number, IPropertySearchInstances>,
    ): Promise<IPropertySearchInstances> => {
      const result = payload.id
        ? await adminRequest.put<IPropertySearchInstances>(cloneResourcePath, payload.data)
        : await adminRequest.post<IPropertySearchInstances>(cloneResourcePath, payload.data);

      const savedRecord = { ...payload.data, ...result.data } as IPropertySearchInstances;

      ctx.commit('set', savedRecord);

      return savedRecord;
    },
  },
};
